// Raffle translations in English
const sorteo = {
    title: "Zaquiel Comic Raffle - Participate and Win!",
    description: "Participate in the Zaquiel Comic raffle.",
    exclusiveRaffle: "Exclusive Raffle!",
    participateAndWin: "Participate in our exhibition and win incredible prizes",
    howToParticipate: "How to participate?",
    step1: "Read one or more chapters of <1>Zaquiel Comic</1>",
    step2: "Complete the survey with your <1>UEMC university email</1>",
    step3: "Each rated chapter = <1>an extra entry</1>!",
    participateNow: "PARTICIPATE NOW!",
    emailWarning: "You can only participate with your <1>@alumnos.uemc.es</1> email. You can rate each chapter only once.",
    privacyNote: "By participating, you accept our",
    privacyLink: "raffle privacy policy",
    backToComic: "← Back to Zaquiel Comic",
    successTitle: "Participation Registered!",
    successMessage: "Your opinion has been sent. You are now participating in the raffle.",
    successHint: "Have you read more chapters? Send more reviews!",
    rateAnother: "Rate another chapter",
    backToHome: "Back to home"
};

export default sorteo;
